// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Switch_wrapper__3YNp9","switch":"Switch_switch__1Lbwy","dark":"Switch_dark__8KMRw"};